import React from 'react';
import {useTable} from 'react-table';
import {CommonTable} from '../../_common/components/CommonTable/CommonTable';
import styles from './styles.module.scss';

export function Lines({columns, tableData}) {

  return (
    <CommonTable
      tableProps={useTable({columns, data: tableData})}
      customTableHeadColor={'editTransfersTableHeadColor'}
      customTableStyles={styles.tableEdit}
      customContainerID={'editTransfersTableContainer'}
    />
  );
}

export default Lines;
